<template>
  <b-container>
    <div class="b-main-content">
      <b-card class="basic-box-shadow" :title="`Pacchetto: ${this.pkg.name}`">
        <b-card-text>{{ this.pkg.description }}</b-card-text>

        <p>
          <b-link
            v-show="generationStatus === 'ready'"
            @click="handleDownloadButton()"
            class="card-link"
          >Genera link di download</b-link>
        </p>

        <p v-show="generationStatus === 'submitting'">
          <b-spinner style="width: 1.4rem; height: 1.4rem;" label="Loading..."></b-spinner>&nbsp;Generando link di download...
        </p>

        <p v-show="generationStatus === 'submitting'">
          <b-progress :max="max" class="mb-3">
            <b-progress-bar :value="progress" :label="`${((progress / max) * 100).toFixed(1)}%`"></b-progress-bar>
          </b-progress>
        </p>

        <p v-show="generationStatus === 'done'">
          <v-icon name="check" base-class="done-icon green"></v-icon>&nbsp;Generati link di download
        </p>

        <p v-show="generationStatus === 'info'">
          <v-icon name="info" base-class="info-icon"></v-icon>
          &nbsp;{{ infoMessage }}
        </p>

        <div v-show="dataEntries || dataIncludePath">
          <h5>Istruzioni</h5>

          <p>Fai click sul nome del file per scaricarlo.</p>

          <h5>Link di download</h5>

          <ol v-show="dataEntries">
            <li v-for="(entry, index) in dataEntries" :key="index">
              <b-link target="_blank" :href="entry.url">
                {{
                entry.name
                }}
              </b-link>
            </li>
          </ol>

          <ol v-show="dataIncludePath">
            <li v-for="(includePath, index) in dataIncludePath" :key="index">
              <b-link @click="downloadFile(includePath)">
                {{
                includePath.key.split('/')[
                includePath.key.split('/').length - 1
                ]
                }}
              </b-link>
            </li>
          </ol>
        </div>
      </b-card>
    </div>
  </b-container>
</template>

<script>
/*
  This page shows the package information to the user and the files inside it
*/

import { mapState, mapGetters } from 'vuex'
import store from '@/store'
import router from '@/router'
import Auth from '@/services/AuthService'

const { sleep } = require('sleep-async')().Promise

export default {
  data () {
    return {
      id: this.$route.params.id,
      generationStatus: 'ready',
      infoMessage: '',
      dataEntries: null,
      dataIncludePath: null,
      retry: true,
      progress: 0,
      max: 100
    }
  },
  computed: {
    ...mapState({
      pkg (state) {
        try {
          return state.packages.packages.find(pkg => pkg.package_id === this.id)
        } catch (err) {
          router.push({
            name: 'signIn',
            params: {
              alert: {
                title: 'Problema di rete', message: 'Si è verificato un problema di rete, riprova.'
              }
            }
          }).catch(err => console.error(err))
        }
      },
      ...mapGetters('packages', [
        'downloadStatus',
        'dlStatusDetails',
        'entries',
        'includePath'
      ])
    })
  },
  mounted () {
    this.$nextTick(function () {
      // retrieve the package files
      this.downloadPackage()
    })
  },
  methods: {
    async handleDownloadButton () {
      this.progress = 0
      this.downloadPackage()
    },
    async downloadPackage () {
      try {
        this.generationStatus = 'submitting'

        // Reset component data
        this.infoMessage = ''
        this.dataEntries = null
        this.dataIncludePath = null

        await store.dispatch('packages/downloadPackage', {
          packageId: this.id,
          // update the progess bar
          // TODO: check progress bar flow bug
          callbacks: {
            onStart: () => {
              if (this.progress <= 12.5) this.progress = 12.5
              setTimeout(() => {
                if (this.progress <= 25) this.progress = 25
              }, 125)
              setTimeout(() => {
                if (this.progress <= 37.5) this.progress = 37.5
              }, 500)
            },
            onAddToCart: () => {
              if (this.progress <= 50) this.progress = 50
              setTimeout(() => {
                if (this.progress <= 62.5) this.progress = 62.5
              }, 450)
            },
            onCheckoutCart: () => {
              if (this.progress <= 75) this.progress = 75
              setTimeout(() => {
                if (this.progress <= 87.5) this.progress = 87.5
              }, 400)
            }
          }
        })

        if (
          this.downloadStatus &&
          this.dlStatusDetails !== 'manifest succesfully generated'
        ) {
          // if the manifest generation didn't go through, show an info message
          this.infoMessage = this.dlStatusDetails
          this.generationStatus = 'info'
          if (this.downloadStatus === 'unable_to_process') {
            await sleep(6000)
          } else {
            await sleep(3000)
          }

          this.generationStatus = 'ready'
          return
        }

        if (this.entries && this.entries.length >= 1) {
          if (this.progress <= 100) this.progress = 100
          await sleep(400)
          // if the generation went through, show the files
          this.dataEntries = this.entries.map(entry => {
            entry.name = entry.url.split('/')[5].split('?')[0]
            return entry
          })

          if (!this.includePath) {
            // if there are no 'include_path' files, show a checkmark icon for a short amount of time
            this.generationStatus = 'done'
            await sleep(1500)
            this.generationStatus = 'ready'
            return
          }
        }

        if (this.includePath && this.includePath.length >= 1) {
          if (this.progress <= 100) this.progress = 100
          await sleep(400)

          this.dataIncludePath = this.includePath.filter(entry => entry.key[entry.key.length - 1] !== '/')
          // show a checkmark icon for a short amount of time
          this.generationStatus = 'done'
          await sleep(1500)
          this.generationStatus = 'ready'
          return
        }

        // if (this.retry && (!this.entries && !this.includePath)) {
        // retry to generate file links for a second time
        this.retry = false
        this.downloadPackage()
        //   return
        // }

        // // if something went wrong, show a default error message for a brief amount of time
        // this.infoMessage = 'Si è verificato un problema, riprovare'
        // this.generationStatus = 'info'
        // await sleep(1750)
        // this.generationStatus = 'ready'
      } catch (err) {
        // if something went wrong, show a default error message for a brief amount of time
        this.infoMessage = 'Si è verificato un problema, riprovare'
        this.generationStatus = 'info'
        await sleep(1750)
        this.generationStatus = 'ready'

        console.error(err)
        const h = this.$createElement

        const vNodesMsg = h(
          'p',
          { class: ['mb-0'] },
          [
            'Si è verificato un problema durante lo scaricamento, riprova.',
            h('br', { class: ['mb-1'] }),
            h('strong', {}, 'Errore:'),
            ` ${err.message}`
          ]
        )

        // show a toast if there was an error during the download
        this.$bvToast.toast([vNodesMsg], {
          title: 'Errore durante lo scaricamento',
          autoHideDelay: 4000,
          appendToast: false,
          variant: 'danger',
          solid: true
        })
      }
    },
    async downloadFile (includePath) {
      let jwtToken

      try {
        jwtToken = await Auth.getJwtToken()
      } catch (err) {
        await store.dispatch('auth/expiredSessionSignOut')
        return
      }

      const token = ['Bearer tk:', jwtToken].join('')

      // example file key: datacatalog-data/analytics/communities_and_topics/json_yearly/year=2011/period=YEAR/YEAR_communities_and_topics.json

      const url = [
        window.origin,
        includePath.key
      ].join('')

      const config = {
        headers: {
          Authorization: token
        }
      }

      try {
        // retrieve file and build download url
        const response = await fetch(url, config)
        const downloadUrl = window.URL.createObjectURL(await response.blob())

        // build the file name
        const includePathSplit = includePath.key.split('/')
        const fileName = includePathSplit[includePathSplit.length - 1]

        // create anchor element
        let anchor = document.createElement('a')
        anchor.style.dislay = 'none'
        anchor.href = downloadUrl
        anchor.download = fileName

        // append anchor and click
        document.body.appendChild(anchor)
        anchor.click()

        window.URL.revokeObjectURL(downloadUrl)

        // pass anchor to garbage collector
        anchor = null
      } catch (err) {
        console.error(err)
        const h = this.$createElement

        const vNodesMsg = h(
          'p',
          { class: ['mb-0'] },
          [
            'Si è verificato un problema durante lo scaricamento, riprova.',
            h('br', { class: ['mb-1'] }),
            h('strong', {}, 'Errore:'),
            ` ${err.message}`
          ]
        )

        // show a toast if there was an error during the download
        this.$bvToast.toast([vNodesMsg], {
          title: 'Errore durante lo scaricamento',
          autoHideDelay: 4000,
          appendToast: false,
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>

<style scoped>
.table-link {
  color: var(--color-base);
  text-decoration: none;
}

.v-icon {
  width: 24px;
  height: 24px;
  color: var(--color-base);
}

.table-link:hover,
.v-icon:hover {
  color: var(--color-hover);
}

.table-link:active,
.v-icon:active {
  color: var(--color-active);
}
</style>
